import type { Case, CaseItem } from "../../api/types.ts"
import { ItemsEditor } from "../ItemsEditor.tsx"
import { InvoiceDownload } from "./InvoiceDownload.tsx"

/** 인보이스 품목. 편집기는 그대로 쓰고 자리만 잡아 준다. */
export function ItemsTab({
  item,
  items,
  editable,
  onSaved,
}: {
  item: Case
  items: CaseItem[]
  editable: boolean
  onSaved: () => void
}) {
  return (
    <ItemsEditor
      caseId={item.id}
      items={items}
      editable={editable}
      onSaved={onSaved}
      // 인보이스는 이 품목들로 만들어진다. 그래서 내려받기도 같은 카드에 둔다.
      headerActions={<InvoiceDownload item={item} itemCount={items.length} />}
    />
  )
}
